import Select from '../../../src/index';
import '@_nu/css-select';
import '@_nu/css-select/lib/skins/default.css';
import './index.css';

export default Select;
